/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.unhide_links.init());

App.unhide_links = {
  init() {
    return $(document)
      .off("click", "[data-unhides]", App.unhide_links.clicked)
      .on("click", "[data-unhides]", App.unhide_links.clicked);
  },

  clicked(evt) {
    evt.preventDefault();
    const target = $(this).attr("data-unhides");
    return $(target).show();
  }
};
    